import { createMVCommentAttachmentsUppy } from '@services/MVCommentAttachmentsUppy';

const uppyCache = new Map<
  string,
  ReturnType<typeof createMVCommentAttachmentsUppy>
>();

function getOrCreateUppy(assetId: string, versionId: string) {
  const cacheKey = `${assetId}:${versionId}`;
  let ctx = uppyCache.get(cacheKey);
  if (!ctx) {
    ctx = createMVCommentAttachmentsUppy(assetId, versionId);
    uppyCache.set(cacheKey, ctx);
  }
  return ctx;
}

export function useMVCommentAttachUppy(assetId: string, versionId: string) {
  return getOrCreateUppy(assetId, versionId).uppy;
}
